const routes = [
	{
		path: '/correos',
		component: () => import('@/views/dashboard/emails/List.vue'),
		meta: {
			auth: true,
		}
	}
];

export default routes;